import { takeEvery, call, put } from 'redux-saga/effects';
import {
    fetchLeadersStart,
    fetchLeadersSuccess,
    fetchLeadersFail,
    createLeaderStart,
    createLeaderSuccess,
    createLeaderFail,
    updateLeaderStart,
    updateLeaderSuccess,
    updateLeaderFail,
    importLeadersCsvStart,
    importLeadersCsvSuccess,
    importLeadersCsvFail,
} from '../slices/leadersSlice';
import { getRequest, postRequest, putRequest, uploadFiles } from '../../network';
import { getLeaders, createLeader, updateLeader, importLeadersCsv } from '../apis';

function* leadersApiSaga(action) {
    const {
        endpoint,
        method = 'get',
        successAction,
        failAction,
        payload = null,
        callback = null,
    } = action.payload;
    const requestFunction =
        method === 'post' ? postRequest : method === 'put' ? putRequest : getRequest;

    try {
        const response = yield call(requestFunction, endpoint, payload);
        if (callback && typeof callback === 'function') {
            yield call(callback, true);
        }
        yield put(successAction(response));
    } catch (error) {
        if (callback && typeof callback === 'function') {
            let errorMessage = 'Something went wrong';
            if (error.response && error.response.data) {
                const data = error.response.data;
                if (data.message && data.errors) {
                    errorMessage = `${data.message}: ${data.errors.join(', ')}`;
                } else if (data.message) {
                    errorMessage = data.message;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            yield call(callback, false, errorMessage);
        }
        yield put(failAction(error.message));
    }
}

function* fetchLeadersSaga(action) {
    yield leadersApiSaga({
        payload: {
            endpoint: getLeaders,
            payload: action.payload,
            successAction: fetchLeadersSuccess,
            failAction: fetchLeadersFail,
        },
    });
}

function* createLeaderSaga(action) {
    yield leadersApiSaga({
        payload: {
            endpoint: createLeader,
            method: 'post',
            payload: action.payload.data,
            callback: action.payload.callback,
            successAction: createLeaderSuccess,
            failAction: createLeaderFail,
        },
    });
}

function* updateLeaderSaga(action) {
    yield leadersApiSaga({
        payload: {
            endpoint: updateLeader.replace(':id', action.payload.id),
            method: 'put',
            payload: action.payload.data,
            callback: action.payload.callback,
            successAction: updateLeaderSuccess,
            failAction: updateLeaderFail,
        },
    });
}

function* uploadLeadersCsvSaga(action) {
    const { endpoint, successAction, failAction, payload, callback } = action.payload;
    const file = payload?.file || payload?.payload;
    try {
        const response = yield call(uploadFiles, endpoint, file, {}, { timeout: 600000 });
        if (callback && typeof callback === 'function') {
            yield call(callback, true, response);
        }
        yield put(successAction(response ?? null));
    } catch (error) {
        const message =
            error.response?.data?.message || error.message || 'Upload failed';
        if (callback && typeof callback === 'function') {
            yield call(callback, false, message);
        }
        yield put(failAction(message));
    }
}

function* importLeadersCsvSaga(action) {
    yield uploadLeadersCsvSaga({
        payload: {
            endpoint: importLeadersCsv,
            payload: action.payload,
            callback: action.payload.callback,
            successAction: importLeadersCsvSuccess,
            failAction: importLeadersCsvFail,
        },
    });
}

export function* watchLeaders() {
    yield takeEvery(fetchLeadersStart.type, fetchLeadersSaga);
    yield takeEvery(createLeaderStart.type, createLeaderSaga);
    yield takeEvery(updateLeaderStart.type, updateLeaderSaga);
    yield takeEvery(importLeadersCsvStart.type, importLeadersCsvSaga);
}
